<app-announcement-bar></app-announcement-bar>
<app-navbar-user [active]="'results'"></app-navbar-user>
<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<div class="container-fluid dashboard  p-4 main-content">
    <div class="row">
        <div class="col-md-12 mb-3">
            <div class="d-md-flex align-items-center justify-content-between d-block">
                <div class="d-flex align-items-center">
                    <h2 class="m-0 page-title"><i class="bx bxs-bar-chart-alt-2"></i> Results</h2>
                </div>

            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="row pt-2" *ngIf="allStats && allStats?.totalPlays > 0 && sessions">
                <div class="col-xl-12 d-flex">

                    <div class="card  w-100 shadow-sm">
                        <div class="card-header d-flex justify-content-between align-items-center">

                            <h5 class="card-title mb-0">Plays <span class="badge badge-sm  me-1 bg-info">{{
                                    sessions.length
                                    }}</span></h5>

                                    <div class="d-flex justify-content-end" style="flex: 1">
            <!--button class="btn btn-darken btn-sm me-2" (click)="onDownloadLogs(sessions)">
              <i class="bx bx-download"></i> Download Logs
            </button-->
            <div class="btn-group me-2" dropdown [container]="'body'" [insideClick]="true" #dropdownCols="bs-dropdown">
              <button id="button-columns" dropdownToggle type="button" class="btn btn-darken btn-sm"
                aria-controls="dropdown-columns">
                <i class="bx bx-filter-alt"></i> Filter Scenarios
                <i class="bx bx-chevron-down"></i>
              </button>
              <ul *dropdownMenu class="dropdown-menu  dropdown-menu-sm dropdown-menu-scroll position-relative"
                aria-labelledby="button-columns">
                <li *ngFor="let libraryItem of libraryItems;">
                  <a class="dropdown-item" (click)="onFilterScenario(libraryItem.library_item_id)" [ngClass]="{
              'selected fw-bold':checkFilter(libraryItem.library_item_id)}"> {{libraryItem.scenario_title}} <i
                      *ngIf="checkFilter(libraryItem.library_item_id)" class="bx bx-check"></i></a>
                </li>
                <li class="d-flex justify-content-center" style="position: sticky;bottom:0;left:0;width:100%;background-color:#fff;"><button class="btn btn-sm btn-darken m-2 mx-auto" style="font-size:0.75rem;"
                    (click)="dropdownCols.hide();onApplyFilter();">Apply</button></li>
              </ul>
            </div>
          </div>




                        </div>
                        <div class="card-body pt-2 pb-3" style="min-height: 140px;" *ngIf="sessions">
                            <div class="chart chart-sm">
                                <p *ngIf="filteredSessions.length==0" class="text-center">No plays found </p>
                                <app-data-table *ngIf="filteredSessions.length>0" [rows]="filteredSessions" [cols]="[
      { name: 'Date', id: 'created', sortable: true },
      { name: 'Scenario', id: 'published.title', sortable: true },
      { name: 'Duration (hh:mm:ss)', id: 'duration', sortable: true, format:'duration' },
      { name: 'Score', id: 'score', sortable: true },
      {
        name: '',
        id: '',
        textAlign:'end',
        sortable:false,
        buttons: [
          {
            link: ['/results', 'row.scenario_session_id'],
            text: 'View',
            icon: 'bx bx-chevron-right',
          }
        ]
      }
    ]" [sort]="'created'" [order]="'desc'" [tableClass]="'table-sm data-table-alt table-borderless'"
                                    [paginationClass]="'pagination-sm'"></app-data-table>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>